import config from 'app/config';
import request from 'superagent';

export default key =>
  new Promise((resolve, reject) => {
    const apiHost = config.get('AUTH_HOST');
    const endpoint = `${apiHost}/v1/password-reset/validate-key/${key}`;

    request.post(endpoint).end((err, res) => {
      if (err) {
        return reject(err);
      }
      return resolve(res.body);
    });
  });
